import React from 'react';
import { connect } from 'react-redux'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, Breadcrumb, FloatButton } from 'antd';

import { PageHeader } from 'components/header';
import { isAuth, _setAxios, getParamTable, getParamTempTableFiltering } from '../../../../lib/Helper';

import AuthRedirect from '../../../../components/redirect/AuthRedirect'
import Detail from '../modal/Detail';
import Filter from '../modal/Filter';
import Desktop from './Desktop';
import Mobile from './Mobile';
import SortingTableDesktopWithFilter from '../../../../components/sorting-table/SortingTableDesktopWithFilter';
import SortingTableMobileWithFilter from '../../../../components/sorting-table/SortingTableMobileWithFilter';
import SearchTable from '../../../../components/search-table/SearchTable';
import { DoubleRightOutlined } from '@ant-design/icons';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}]

class PresensiSiswa extends React.Component {


  constructor(props) {
    const { privilege } = props
    const { tahun_ajaran, semester} = privilege
    super(props)
    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {
          aktivitas: "PEMBELAJARAN KELAS",
          tahun_ajaran_id: tahun_ajaran?.id,
          semester_id: semester?.id
        },
      },
      filter: {
        values: {
          tahun_ajaran_id: tahun_ajaran?.id,
          semester_id: semester?.id
        },
        visible: false,
      },
      detail: {
        data: {},
        visible: false
      },
    };
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isNew ? 1 : params.pagination.current
      }
    }
    _setAxios("presensi/siswa/kehadiran/table", "POST", params).then(resp => {

      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }


  // FILTER START ------------------------------------------
  setTempTableFilter = (name, value) => {

    let values = this.state.filter.values
    values[name] = value

    this.setState({
      filter: {
        ...this.state.filter,
        values: values
      }
    })

  };

  setTableFilterFromTemp = () => {
    const params = getParamTempTableFiltering(this.state.table, this.state.filter.values)
    this.fetch(params, isMobile ? true : false)
    this.modalFilter(false)
  };

  modalFilter = (visible = false) => {
    this.setState({
      filter: {
        ...this.state.filter,
        visible: visible,
      },
    })
  }
  // FILTER END ------------------------------------------

  modalForm = (visible = false, data = {}) => {
    this.setState({
      form: {
        data: {
          ...data,
          ruangan_id: data.ruangan_id ? {
            id: data.ruangan_id,
            nama: data.ruangan_nama
          } : null
        },
        visible: visible
      },
    })
  }

  modalDetail = (visible = false, data = {}) => {
    this.setState({
      detail: {
        data: data,
        visible: visible
      },
    })
  }

  render() {

    const access = this.props.privilege.access["/presensi/siswa"]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    const { table } = this.state;

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />} items={[
            { title: 'Presensi' },
            { title: 'Siswa' },
          ]} />}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>

          <PageHeader
            className="site-page-header"
            title="Siswa"
            subTitle="Data kehadiran siswa"
          />
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={18} md={19} >
              <SearchTable table={table} fetch={this.fetch} />
            </Col>

            {/* SORTING LIST/TABLE */}
            <Col xs={24} sm={6} md={5}>
              <SortingTableMobileWithFilter isFilter={true} table={table} fetch={this.fetch} modalFilter={this.modalFilter} sortFields={sortFields} />
              <SortingTableDesktopWithFilter table={table} fetch={this.fetch} modalFilter={this.modalFilter} sortFields={sortFields} />
            </Col>

            {/* LIST/TABLE DATA */}
            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalForm={(visible, data) => {
                    this.modalForm(visible, data)
                  }}
                  modalDetail={this.modalDetail}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalForm={(visible, data) => {
                    this.modalForm(visible, data)
                  }}
                  modalDetail={this.modalDetail}
                />
              </MobileView>
            </Col>

          </Row>

          {
            this.state.filter.visible ?
              <Filter
                values={this.state.filter.values}
                open={this.state.filter.visible}
                hideModal={this.modalFilter.bind(this, false)}
                setTempTableFilter={this.setTempTableFilter}
                setTableFilterFromTemp={this.setTableFilterFromTemp}
              /> : ""
          }
          {
            this.state.detail.visible ?
              <Detail
                data={this.state.detail.data}
                open={this.state.detail.visible}
                hideModal={this.modalDetail.bind(this, false)}
                fetchTable={this.fetchTable}
              /> : ""
          }
          <FloatButton.BackTop />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(PresensiSiswa);
